import React from "react";
import CloseIcon from "../../assets/Icons/CloseIcon";
import Button from "../Partial/Button";

function SuccessModal({ userData, onClose }) {
  return (
    <div className="w-full h-screen fixed top-0 left-0 bg-gray-600 bg-opacity-50 flex justify-center items-center">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full sm:w-3/4 md:w-1/2 lg:w-1/3 relative">
        <div
          className="absolute right-4 top-4 cursor-pointer"
          onClick={onClose}
        >
          <CloseIcon />
        </div>
        <h2 className="text-lg font-bold mb-4">User Details</h2>
        <p>
          <strong>Name:</strong> {userData?.name}
        </p>
        <p>
          <strong>Email:</strong> {userData?.email}
        </p>
        <p>
          <strong>Status:</strong> {userData?.status}
        </p>
        <p>
          <strong>Password:</strong> {userData?.password}
        </p>
        <Button
          text="Close"
          onClick={onClose}
          className="mt-4 w-full bg-blue-500 text-white py-2 rounded"
        />
      </div>
    </div>
  );
}

export default SuccessModal;
